<template>
  <div class="main">
    <Banner :banner="banner" />
    <Headlines :headlines="headlines" />

    <div class="content-box">
      <div class="left-box">
        <Article :article="broadcast" />
        <Article :article="review" />
        <Project :project="project" />
      </div>

      <Rightbox />
    </div>
  </div>
</template>

<script>
export default {
  name: "yqchdjk",
  // meta配置
  metaInfo: {
    title:
      "【专题】" + "疫情催化下加速发展 腾讯 经纬中国等持续布局互联网大健康",
    meta: [
      {
        name: "keywords",
        content: "疫情 腾讯 经纬中国 IDG 红杉 投资 布局 互联网大健康",
      },
      {
        name: "description",
        content:
          "疫情催化下，互联网医疗迎来了加速发展。据网经社电子商务研究中心发布的《2021年（上）中国互联网大健康市场数据报告》显示，2020年互联网大健康市场规模为3426.4亿元，预计2021年达到4465亿元，同比增长30.31%。广阔的市场前景引来了腾讯、阿里等巨头以及经纬中国、红杉资本等VC/PE的布局。",
      },
    ],
  },
  data() {
    return {
      // 头图标题
      banner: {
        img: require("@/assets/yqchdjk/banner.jpg"),
        title: ["疫情催化下加速发展 腾讯 经纬中国等持续布局互联网大健康", ""],
        text: "疫情催化下，互联网医疗迎来了加速发展。据网经社电子商务研究中心发布的《2021年（上）中国互联网大健康市场数据报告》显示，2020年互联网大健康市场规模为3426.4亿元，预计2021年达到4465亿元，同比增长30.31%。广阔的市场前景引来了腾讯、阿里等巨头以及经纬中国、红杉资本等VC/PE的布局。",
      },

      // 置顶头条
      headlines: [
        {
          title:
            "盘点：红杉资本互联网大健康布局：投资14起 猛砸微医 妙手医生 更美",
          url: "/detail--6600882.html",
        },
        {
          title: "盘点：IDG资本互联网大健康布局 投资15起涉及平安好医生 微脉等",
          url: "/detail--6600558.html",
        },
        {
          title: "盘点：7年164.8亿元 腾讯“投资+自建”布局互联网大健康",
          url: "/detail--6598777.html",
        },
        {
          title: "盘点：经纬中国互联网大健康布局 投资23起 金额超31.8亿元",
          url: "/detail--6598989.html",
        },
      ],

      // 滚动播报
      broadcast: {
        title: {
          topic: "滚动播报",
        },
        nav: [
          {
            value: "医药 投资",
            label: "医药",
          },
          {
            value: "医疗 投资",
            label: "医疗",
          },
        ],
        params: {
          p: 1,
          n: 5,
          terms: "医药 投资",
        },
      },

      // 相关平台
      review: {
        title: {
          topic: "相关平台",
          more: {
            name: "企业库>",
            url: "http://cop.100ec.cn/",
          },
        },
        nav: [
          {
            value: "腾讯",
            label: "腾讯",
          },
          {
            value: "经纬中国",
            label: "经纬中国",
          },
          {
            value: "IDG",
            label: "IDG",
          },
          {
            value: "红杉",
            label: "红杉",
          },
        ],
        params: {
          p: 1,
          n: 5,
          terms: "腾讯",
        },
      },

      // 相关专题
      project: {
        title: {
          topic: "相关专题",
        },
        params: {
          p: 1,
          name: "公司类",
          title: "投资",
        },
      },
    };
  },
};
</script>

<style>
</style>
